import { render } from "./ProjectCardList.vue?vue&type=template&id=83b53a26"
const script = {}

import "./ProjectCardList.vue?vue&type=style&index=0&id=83b53a26&lang=css"

import exportComponent from "C:\\Users\\TOP\\Desktop\\vue\\nomad-poc-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__